<div class="container-fluid">
  <page-header-search
    [isSearchInput]="true"
    [pageTitleValue]="pageTitle"
    placeholderValue="Search by patient name or mobile number or Psp Code …"
    (onHeaderSearchSubmit)="onSearchPatients($event)"
    [searchString]="searchValue"
  >
    <div class="row mt-3">
      <div class="col-12 d-flex align-items-center">
        <h5 class="filter">Filter By</h5>
        <div class="filter-btn-container ml-4">
          <button *ngFor="let filter of filters" class="btn btn-filter" [ngClass]="{'active': filter.statusId === statusId}" (click)="onSearch(filter.statusId)">
            {{ filter.label }}
          </button>
        </div>
      </div>
    </div>
  </page-header-search>

  <div class="card">
    <div class="card-header border-0 pt-0 pb-0">
      <div class="d-flex justify-content-between row">
        <div class="d-flex col-md-10 align-items-center">
          <h3 class="mr-3">{{ titles[statusId] }}</h3>

          <button class="btn btn-neutral mr-2" (click)="addExportRequest()">
              <span class="btn-inner--icon">
                <i class="ni ni-cloud-download-95"> </i>
              </span>
            <span class="btn-inner--text"> Download as Excel </span>
          </button>

          <div class="col-md-3">
            <app-companies-select (companySelected)="onCompanySelected($event)" [designClasses]="'active'"></app-companies-select>
          </div>
        </div>

        <span>
            <a (click)="invertSorting()">
              <span>↑</span>
              <span class="ml--1">↓</span>
              Sort By
            </a>
          </span>
      </div>
    </div>
    <div class="card-body">
      <ngx-datatable class="material ngx-datatable-custom" [rows]="requestArray"
        [columns]="columns" [limit]="apiParams.pageSize" [offset]="apiParams.currentPage-1"
        columnMode="force" externalPaging="true" [count]="totalItems" [scrollbarH]="true"
        [headerHeight]="50" [footerHeight]="50" rowHeight="auto" (page)="onChangePage($event)"
        selectionType="single" (select)="routeToRequestDetails($event)" [messages]="messages">
        
        <ng-template let-row="row" #selectPharmacy ngx-datatable-row-detail-template>
          <span>
            {{ row?.pharmacy?.name }} - {{ row?.pharmacy?.address }}
          </span>
        </ng-template>

        <ng-template #subscriptionHistoryTemplate let-row="row" ngx-datatable-cell-template>
          <div [ngClass]="isArabic(row.subscriptionHistory) ? 'rtl-text' : 'ltr-text'">
            {{ row.subscriptionHistory }}
          </div>
        </ng-template>

        <ng-template #packSerialNumberTemplate let-row="row" ngx-datatable-cell-template>
          <span *ngIf="row.boxes && row.boxes.length === 1">
            Pack Serial Number: {{ row.boxes[0].serialNumber }}
          </span>
          <span *ngIf="row.boxes && row.boxes.length > 1" 
                [pTooltip]="getBoxesTooltip(row.boxes)" tooltipPosition="top">
            Pack 1 Serial Number: {{ row.boxes[0].serialNumber }}...
          </span>
        </ng-template>

        <ng-template #previewReceiptDocumentRef let-row="row" ngx-datatable-row-detail-template>
        <div>
          <button class="btn btn-success" 
          (click)="onReceiptDocumentButtonClick(row , $event)"
          (dblclick)="onReceiptDocumentButtonClick(row, $event)"
          [disabled]="!hasReceiptDocument(row)">
          Preview</button>
        </div>
      </ng-template>

      <ng-template #previewSerialNumberDocumentRef let-row="row" ngx-datatable-row-detail-template>
        <div>
          <button class="btn btn-success" 
          (click)="onSerialNumberDocumentButtonClick(row , $event)"
          (dblclick)="onSerialNumberDocumentButtonClick(row, $event)"
          [disabled]="!hasSerialNumberDocument(row)">
          Preview</button>
        </div>
      </ng-template>

        <ng-template let-row="row" #cancelBtnRef ngx-datatable-row-detail-template>
          <button *ngIf="row.canCancel" class="btn btn-danger btn-sm" (click)="cancelClicked($event, row, i)">
            Cancel
          </button>
        </ng-template>
      </ngx-datatable>
    </div>
  </div>
</div>
<ngx-spinner></ngx-spinner>
